module.exports = __webpack_public_path__ + "static/media/shape1_2.7fb08af8.obj";